import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { CONTACT_EMAIL, ICP_NUMBER } from '../constants/content';

export default function PrivacyPage() {
  return (
    <>
      <PageHero
        title="隐私政策"
        subtitle="我们重视并保护您的个人信息。本政策说明 Ameowzing 如何收集、使用与保护您的数据。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '隐私政策' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto prose prose-invert space-y-8 text-purple-200 text-sm leading-relaxed">
          <PolicySection title="1. 信息收集">
            <p>我们可能收集以下类型的信息：</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>账号信息：手机号、邮箱或第三方登录标识（用于账号注册与登录）</li>
              <li>练习记录：您主动进行的冥想练习内容、课程进度与 AI 引导记录（存储于您的账号下）</li>
              <li>设备信息：设备型号、操作系统版本、APP 版本（用于兼容性支持与故障排查）</li>
              <li>蓝牙设备信息：配对设备的标识符（仅用于设备联动功能）</li>
            </ul>
          </PolicySection>

          <PolicySection title="2. 信息使用">
            <p>我们收集的信息将用于：</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>提供冥想练习、历史记录同步等核心服务</li>
              <li>优化 AI 引导质量与用户体验</li>
              <li>响应技术支持请求与账号相关问题</li>
              <li>发送与服务相关的重要通知（如政策更新）</li>
            </ul>
            <p className="mt-4">我们不会将您的个人练习内容出售给第三方，也不会用于与核心服务无关的商业目的。</p>
          </PolicySection>

          <PolicySection title="3. 信息存储与安全">
            <p>
              您的数据存储于受保护的服务器，传输过程采用加密技术。我们采取合理的技术与管理措施防止未经授权的访问、泄露或篡改。
            </p>
          </PolicySection>

          <PolicySection title="4. 您的权利">
            <p>您有权：</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>在 APP 设置中查看、导出或删除冥想练习记录</li>
              <li>修改账号绑定信息</li>
              <li>申请注销账号（注销后数据将在 15 个工作日内删除且不可恢复）</li>
              <li>通过 {CONTACT_EMAIL} 咨询隐私相关问题</li>
            </ul>
          </PolicySection>

          <PolicySection title="5. 第三方服务">
            <p>
              APP 可能接入第三方登录（如微信、Apple ID）或应用商店服务，这些服务有各自的隐私政策。我们仅获取实现登录所必需的最少信息。
            </p>
          </PolicySection>

          <PolicySection title="6. 政策更新">
            <p>
              我们可能适时修订本政策，修订后将在 APP 或官网公布。重大变更将通过 APP 内通知等方式告知您。
            </p>
          </PolicySection>

          <p className="text-purple-400 text-xs pt-8 border-t border-purple-900/50">
            最后更新：2026 年 1 月 · 运营主体 ICP：{ICP_NUMBER}
          </p>

          <div className="text-center pt-4">
            <Link to="/terms" className="text-secondary hover:underline">
              查看用户协议 →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

function PolicySection({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-light mb-3">{title}</h2>
      {children}
    </div>
  );
}
